export function getHeaders() {
  const headers = [
    {
      text: 'Invoice Number',
      className: 'fixed-cell left',
    },
    {
      text: 'finance.customer_code',
    },
    {
      text: 'finance.purchase_date',
    },
    {
      text: 'Invoice Date',
    },
    {
      text: 'Payer Name',
    },
    {
      text: 'Phone Number',
    },
    {
      text: 'finance.collection_type',
    },
    {
      text: 'finance.currency',
    },
    {
      text: 'finance.exchange_rate',
    },
    {
      text: 'finance.paid_amount',
    },
    {
      text: 'finance.invoice_amount',
    },
    {
      text: 'finance.discount',
    },
    {
      text: 'finance.remaining_balance',
    },
    {
      text: 'finance.reference_number',
    },
    {
      text: 'waybill_entry.operator',
    },
    {
      text: 'waybill_entry.remark',
    },
    {
      text: 'actions',
      className: 'fixed-cell',
      width: 100,
    },
  ];

  return headers;
}
